type Attributes = Record<string, unknown>;

export const SAVE_AND_TEST_ACTION = "saveAndTest";

export const isSaveAndTestAction = (saveAction: unknown): boolean =>
  typeof saveAction === "string" &&
  saveAction.trim() === SAVE_AND_TEST_ACTION;

export const prepareTestAdditionalDataForSaveAction = <T extends Attributes>(
  attributes: T,
  saveAction: unknown,
  shouldIncludeTestAdditionalData: boolean,
  buildTestAdditionalData?: () => string
): T => {
  if (!attributes || typeof attributes !== "object") {
    return attributes;
  }

  if (
    !isSaveAndTestAction(saveAction) ||
    !shouldIncludeTestAdditionalData
  ) {
    delete attributes.testAdditionalData;
    return attributes;
  }

  const currentValue = attributes.testAdditionalData;
  const hasValue =
    typeof currentValue === "string" && currentValue.trim() !== "";

  if (!hasValue && typeof buildTestAdditionalData === "function") {
    (attributes as Attributes).testAdditionalData = buildTestAdditionalData();
  }

  return attributes;
};
